import { render, staticRenderFns } from "./Two-column-sidebar.vue?vue&type=template&id=49d6bdb3"
import script from "./Two-column-sidebar.vue?vue&type=script&lang=js"
export * from "./Two-column-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports